<tui-select
  class="iss-select"
  [formControl]="control.control"
  [tuiTextfieldLabelOutside]="true"
  [readOnly]="!!readonly"
  [valueContent]="valueContent"
>
  <ng-container [ngTemplateOutlet]="placeholderTpl"/>
  <ng-template tuiDataList>
    <tui-data-list>
      <button
        *ngFor="let item of items"
        tuiOption
        [value]="identityFn(item)"
      >
        <ng-container
          [ngTemplateOutlet]="selectOption?.templateRef || naive"
          [ngTemplateOutletContext]="{ $implicit: item }"
        />
      </button>
    </tui-data-list>
  </ng-template>
</tui-select>
<ng-template #valueContent let-value>
  <ng-container
    [ngTemplateOutlet]="selectOption?.templateRef || naive"
    [ngTemplateOutletContext]="{ $implicit: value }"
  />
</ng-template>

<ng-template #naive let-item>{{ textFn(item) }}</ng-template>

<ng-template #placeholderTpl>
  <div class="tw-flex tw-items-center tw-justify-between">
    <span>{{ placeholder }}</span>
    <tui-loader *ngIf="loading || control.control.value" [size]="'s'" class="tw-w-[24px]" />
  </div>
</ng-template>
